const caveTubingAlts = ["Safe Family Fun Cave Tubing with Major Tom from Belize City",
"Visit Xunantunich and other exciting Mayan Ruins",
"Beautiful Jungle Scenery in the unforgettable cave tubing experience",
"Visit Altun Ha Mayan Ruins and the famous Jade Skull",
"Bring friends and family and tube through serene jungle into ancient ceremonial Mayan Caves",
"The beautiful jungle river you will tube through on your way to the Caves"
];

export default caveTubingAlts; 